import gql from 'graphql-tag';

export const OBTER_CONFIGURACAO_POR_NOME = gql`
  query ObterConfiguracaoPorNome($configuracaoNome: ConfiguracaoEnum!) {
    obterConfiguracaoPorNome(configuracaoNome: $configuracaoNome) {
      nome
      tipo
      descricao
      valor {
        valorNumber
      }
    }
  }
`;
